module.exports = __webpack_public_path__ + "img/block_6_red_pin.9b85edb4.png";